import React from 'react';
import { Mail, Instagram, Linkedin, Globe } from 'lucide-react';

export const Footer = () => {
  return (
    <footer
      className="py-12 px-4 md:px-6 lg:px-8 bg-[#1A2D23] text-[#FDFCF8]"
      data-testid="footer"
    >
      <div className="container mx-auto max-w-7xl">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_f6a60205-fe70-4887-9d6d-271a2734bf52/artifacts/ebcagad5_Untitled_design_%281%29.png"
              alt="Green Lens Collective"
              className="h-16 md:h-20 w-auto"
            />
          </div>

          {/* Contact Info */}
          <div className="flex flex-col md:flex-row items-center gap-6">
            <a
              href="mailto:hello@greenlenscollective.org"
              className="flex items-center gap-2 hover:text-[#D97706] transition-colors duration-300"
              data-testid="footer-email-link"
            >
              <Mail className="w-5 h-5" />
              <span className="text-sm">hello@greenlenscollective.org</span>
            </a>
            <a
              href="https://greenlenscollective.org"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:text-[#D97706] transition-colors duration-300"
              data-testid="footer-website-link"
            >
              <Globe className="w-5 h-5" />
              <span className="text-sm">greenlenscollective.org</span>
            </a>
            <a
              href="https://www.instagram.com/green.lens.collective"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:text-[#D97706] transition-colors duration-300"
              data-testid="footer-instagram-link"
            >
              <Instagram className="w-5 h-5" />
              <span className="text-sm">@green.lens.collective</span>
            </a>
            <a
              href="https://www.linkedin.com/company/green-lens-collective"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:text-[#D97706] transition-colors duration-300"
              data-testid="footer-linkedin-link"
            >
              <Linkedin className="w-5 h-5" />
              <span className="text-sm">LinkedIn</span>
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-[#2E5C44] text-center">
          <p className="text-sm text-[#E8E6DE]">
            © {new Date().getFullYear()} Green Lens Collective. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;